import { ProjectPageHeader } from "@/components/project/project-page-header";
import { ProjectPage } from "@/components/project/project-page";
import { FilterBar } from "@/components/filter-bar";
import { AutoRefreshIndicator } from "@/components/auto-refresh-indicator";
import { LogsCharts } from "@/components/notification-logs/logs-charts";
import { LogsDatePicker } from "@/components/notification-logs/logs-date-picker";
import { LogsTable } from "@/components/notification-logs/logs-table";
import { EnvironmentSelector } from "@/components/project/environment-selector";
import { useSearchFilters } from "@/hooks/use-search-filters";
import { orpc } from "@/lib/orpc";
import { logsSearchSchema } from "@papier/logs-contracts";
import { useSuspenseQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/projects/$projectSlug/_layout/logs")({
  component: LogsPage,
  validateSearch: logsSearchSchema,
});

function LogsPage() {
  const { useParams } = Route;
  const params = useParams();
  const { filters, setFilters, resetFilters } = useSearchFilters(Route.id);
  const { env, startDate, endDate, query, recipientType, sortBy, status } = filters;

  const { data: project } = useSuspenseQuery(
    orpc.projects.getBySlug.queryOptions({
      input: params,
      ...{
        select: (data) => ({ id: data.id, environments: data.environments }),
      },
    }),
  );
  const envId = env !== "all" ? project.environments.find((e) => e.slug === env)?.id : undefined;

  const filterCount = [
    env && env !== "all",
    startDate || endDate,
    query,
    recipientType?.length,
    status?.length,
    sortBy,
  ].filter(Boolean).length;

  return (
    <ProjectPage>
      <ProjectPageHeader
        title="Logs"
        status={<AutoRefreshIndicator />}
        description="Follow every message from request to delivery."
        actions={
          <EnvironmentSelector
            currentEnv={env || "all"}
            environments={project.environments}
            setEnvironment={(value) => setFilters({ env: value })}
          />
        }
      />
      <FilterBar label="Log filters" activeCount={filterCount} onReset={resetFilters}>
        <div className="w-64 shrink-0">
          <LogsDatePicker />
        </div>
      </FilterBar>
      <LogsCharts projectId={project.id} environmentId={envId} />
      <LogsTable projectId={project.id} environmentId={envId} />
    </ProjectPage>
  );
}
